import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Config from '../../../config';
import {
    GATE_PASS_DETAILS_LOADING,
    FETCH_GATE_PASS_DETAILS_SUCCESS,
    CREATE_GATE_PASS_DETAILS_FORM,
    SET_GATE_PASS_DETAILS_FORM,
    GATE_PASS_DETAILS_FORM_RESET
} from './gatePass.actionsType';

// ---------------------------------------------------------------------------
// TODO (backend): these endpoints don't exist yet. Create them in the
// TblGatePassDetails controller (or rename here to match what you build).
// ---------------------------------------------------------------------------
const ENDPOINTS = {
    LIST: `${Config.baseUrl}/api/TblGatePassDetail/GetTblGatePassDetailofDC`, // GET    ?FldFKDC=
    CREATE: `${Config.baseUrl}/api/TblGatePassDetail/CreateTblGatePassDetail`, // POST   TblGatePassDetails
    UPDATE: `${Config.baseUrl}/api/TblGatePassDetail/UpdateTblGatePassDetail`, // PUT    TblGatePassDetails
    DELETE: `${Config.baseUrl}/api/TblGatePassDetail/DeleteTblGatePassDetail` // DELETE /{id}
};

const authHeaders = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
    dbname: Cookies.get('DATABASE')
});

// Same clean-up as the Gate Pass header: FK fields → integers (empty/0 left
// out), empty values left out, false / 0 quantities kept.
const isFKField = (key) => /^[Ff]ld\w*FK/.test(key);

// Decimal columns on TblGatePassDetail. The form keeps what the user typed as
// text ("1"), but .NET can't read a text value into a decimal, so these are
// always sent as numbers (1). Empty ones are left out.
const DECIMAL_FIELDS = [
    'fldQuantity',
    'fldRate',
    'fldGrossValue',
    'fldDiscountPercentage',
    'fldDiscountValue',
    'fldTaxableValue',
    'fldIGSTPercentage',
    'fldIGSTValue',
    'fldSGSTPercentage',
    'fldSGSTValue',
    'fldCGSTPercentage',
    'fldCGSTValue',
    'fldGSTValue',
    'fldTotalValue'
];

export const buildDetailsPayload = (data) =>
    Object.keys(data).reduce((acc, key) => {
        let value = data[key];
        if (isFKField(key)) {
            const num = parseInt(value, 10);
            if (!Number.isNaN(num) && num !== 0) acc[key] = num;
            return acc;
        }
        if (DECIMAL_FIELDS.includes(key)) {
            if (value === undefined || value === null || String(value).trim() === '') return acc;
            const num = Number(value);
            if (!Number.isNaN(num)) acc[key] = num;
            return acc;
        }
        if (value === undefined || value === null) return acc;
        if (typeof value === 'string') {
            value = value.trim();
            if (value === '') return acc;
        }
        acc[key] = value;
        return acc;
    }, {});

const toList = (data) => {
    const list = Array.isArray(data) ? data : data?.data ?? data?.Data ?? [];
    return Array.isArray(list) ? list : [];
};

export const createGatePassDetailsForm = (key, value) => ({ type: CREATE_GATE_PASS_DETAILS_FORM, key, value });
export const setGatePassDetailsForm = (row) => ({ type: SET_GATE_PASS_DETAILS_FORM, payload: row });
export const resetGatePassDetailsForm = () => ({ type: GATE_PASS_DETAILS_FORM_RESET });

export const fetchGatePassDetails = (gatePassId) => async (dispatch) => {
    if (!gatePassId) return;
    try {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: true });
        //const { data } = await axios.get(ENDPOINTS.LIST, { params: { FldFKDC: gatePassId }, headers: authHeaders() });
        const { data } = await axios.get(`${ENDPOINTS.LIST}/${gatePassId}`, { headers: authHeaders() });
        dispatch({ type: FETCH_GATE_PASS_DETAILS_SUCCESS, payload: toList(data) });
    } catch (error) {
        dispatch({ type: FETCH_GATE_PASS_DETAILS_SUCCESS, payload: [] });
        toast.error(error?.response?.data?.message || 'Failed to fetch Gate Pass details');
    } finally {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: false });
    }
};

export const createGatePassDetails = (formData, gatePassId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: true });
        await axios.post(ENDPOINTS.CREATE, buildDetailsPayload(formData), { headers: authHeaders() });
        toast.success('Gate Pass detail added', { autoClose: 1500 });
        dispatch(fetchGatePassDetails(gatePassId));
        return true;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to add Gate Pass detail');
        return false;
    } finally {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: false });
    }
};

export const updateGatePassDetails = (formData, gatePassId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: true });
        await axios.patch(`${ENDPOINTS.UPDATE}/${formData.fldId}`, buildDetailsPayload(formData), { headers: authHeaders() });
        toast.success('Gate Pass detail updated', { autoClose: 1500 });
        dispatch(fetchGatePassDetails(gatePassId));
        return true;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to update Gate Pass detail');
        return false;
    } finally {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: false });
    }
};

export const deleteGatePassDetails = (id, gatePassId) => async (dispatch) => {
    try {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: true });
        await axios.delete(`${ENDPOINTS.DELETE}/${id}`, { headers: authHeaders() });
        toast.success('Gate Pass detail deleted', { autoClose: 1500 });
        dispatch(fetchGatePassDetails(gatePassId));
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to delete Gate Pass detail');
    } finally {
        dispatch({ type: GATE_PASS_DETAILS_LOADING, payload: false });
    }
};
